export default __webpack_public_path__ + "static/media/Dr._Kate_Steiner_AHV_In_Moms_We_Trust.e6bc652d.jpg";